/*
 * Purpose: Render right panel for legal guardian in Access Shell layout.
 * Boundary: Visible only for minors; provides legal guardian context.
 * Invariants:
 * - Consumes { services, setGuardianState, onTapout, isMobile } from props.
 * - ASCII only; no Unicode in comments or strings.
 * - On mobile: no background styling; on desktop: card-style with border and background
 */
import { useMemo } from 'react';

import LegalGuardian from '../../legalguardian';
import { LegalGuardianContext } from '../../legalguardian';

// Component AccessShellRightPanelLayout:
export default function AccessShellRightPanelLayout({ services, setGuardianState, onTapout, isMobile }) {
  return (
    <div 
      className={
        isMobile 
          ? "relative" 
          : "relative md:border-l md:border-neutral-800 pl-0 md:pl-6 py-3 px-6 rounded-[15px] bg-neutral-900 md:col-span-1"
      }
    >
      {/* Tap-out (X) */}
      <button
        type="button"
        aria-label="Close legal guardian"
        onClick={onTapout}
        className="absolute top-2 right-2 h-8 w-8 rounded-full hover:bg-neutral-800/60 focus:outline-none"
        title="Close"
      >
        X
      </button>

      <LegalGuardianContext.Provider
        value={useMemo(() => ({ setGuardianState }), [setGuardianState])}
      >
        <LegalGuardian services={services} />
      </LegalGuardianContext.Provider>
    </div>
  );
}